import { Button } from "@/components/ui/button";

interface SEOFormActionsProps {
  loading: boolean;
  onFeedbackClick: () => void;
}

export function SEOFormActions({ loading, onFeedbackClick }: SEOFormActionsProps) {
  return (
    <div className="flex flex-col items-center gap-4">
      <Button 
        type="submit" 
        className="w-2/3 bg-blue-600 hover:bg-blue-700"
        disabled={loading}
      >
        {loading ? "Analisando..." : "Analisar URL"}
      </Button>
      <div className="bg-gray-50 rounded-lg p-4 w-full border border-gray-200">
        <p className="text-sm flex items-center gap-2">
          🤖
          <span className="font-bold">Estamos em beta!</span>{" "}
          Queremos ouvir sua opinião.{" "}
          <button
            type="button"
            onClick={onFeedbackClick}
            className="text-blue-600 hover:text-blue-700 underline font-medium inline"
          >
            Deixar feedback
          </button>
        </p>
      </div>
    </div>
  );
}